import { AxiosResponse } from 'axios';
import { SubitemKind } from '@/types/PolicySublimit';
import { SubitemType, SubitemTypeSaveRequest } from '@/types/SubitemType';
import { isAxiosError, Service } from './api';

class SubitemTypeService extends Service {
  async list(kind: SubitemKind): Promise<SubitemType[]> {
    return this.send(this.get<SubitemType[]>(this.path(kind)));
  }

  async create(kind: SubitemKind, request: SubitemTypeSaveRequest): Promise<SubitemType> {
    return this.send(this.post<SubitemType>(this.path(kind), request));
  }

  async update(kind: SubitemKind, id: number, request: SubitemTypeSaveRequest): Promise<void> {
    await this.send(this.put<void>(`${this.path(kind)}/${id}`, request));
  }

  async remove(kind: SubitemKind, id: number): Promise<void> {
    await this.send(this.delete<void>(`${this.path(kind)}/${id}`));
  }

  private path(kind: SubitemKind): string {
    return `/v1/admin/${kind}-types`;
  }

  // The base post resolves with the AxiosError while get/put/delete reject with it; routing both
  // through handleResponse turns either into an Error carrying the API's { error } message.
  // Anything else (e.g. SessionExpiredError from getAuthHeaders) never reached the API and must
  // stay a rejection, or handleResponse would read it as an empty success.
  private send<T>(request: Promise<AxiosResponse<T>>): Promise<T> {
    return request.then(
      (response) => this.handleResponse<T>(response),
      (error) => {
        if (isAxiosError(error)) {
          return this.handleResponse<T>(error);
        }
        throw error;
      },
    );
  }
}

export const subitemTypeService = new SubitemTypeService();
